import React  from 'react';
import Spinner from '../components/Spinner';
// import jwtDecode from 'jwt-decode';
import {inject,observer} from 'mobx-react';
// import { observable, autorun, toJS} from "mobx";
// import {token} from './localStorage';

// export const validateRole = (permission) => {
//   const permissions = token.getPermissions();
//   // console.log(permissions, permission)
//   return +token.getDecoded().role_id === 1 || (permissions && permissions.indexOf(permission) > -1);
// };

export const validateStation = ({folders, stations}, requestedStation) => (!!folders && !!folders.find(item => +item.folder_id === +requestedStation.folder_id)) || (!!stations && !!stations.find(perm => +perm.station_id === +requestedStation.id));

export const checkRolePermission = (Component) => {

  @inject('rolePermissionStore')
  @observer
  class ValidatedComponent extends React.Component{
    render(){
      const {rolePermissionStore} = this.props;
      return(
        rolePermissionStore.validateRole(this.props.route.name) ? <Component {...this.props}/> : <h3>RESOURCE ACCESS DENIED</h3>
      );
    }
  }

  return ValidatedComponent;
};

export const checkStationPermission = (Component) => {

  @inject('stationPermissionStore','stationStore')
  @observer
  class ValidatedComponent extends React.Component{

    // @observable requestedStation = null;
    //
    // componentWillMount(){
    //   this.reset(this.props.params.id);
    // }
    //
    //
    // componentWillReceiveProps(nextProps) {
    //   if(+this.props.params.id !== +nextProps.params.id) this.reset(nextProps.params.id)
    // }
    //
    // reset(id){
    //   if(!this.props.stationStore.items.length) {
    //     setTimeout(() => {
    //       this.reset(id);
    //     }, 500)
    //   } else {
    //     let station = this.props.stationStore.findById(id);
    //     if(!this.requestedStation || this.requestedStation.id !== station.id) this.requestedStation = station;
    //   }
    // }

    render(){
      // return <Component {...this.props} />;

      const { stationStore, stationPermissionStore, params:{id} } = this.props;

      let requestedStation = stationStore.findById(id);

      if(stationPermissionStore.isLoading || !requestedStation) {
        return <Spinner/>
      } else if (!validateStation(stationPermissionStore.items, requestedStation)){
        return(
          <h3>STATION ACCESS DENIED</h3>
        )
      } else {
        return(<Component {...this.props} />)
      }
    }
  }

  return ValidatedComponent
};



// WEBPACK FOOTER //
// ./src/libs/checkPermission.js